

export default {
  props:{
    groupId:{
      type: String,
    }
  },
  data() {
    return {
      modalShow: false,
    }
  },

  methods:{
    chatDelete() {
      this.$axios.delete(`/api/chat/${this.groupId}`)
      .then(()=>{
      alert("채팅방을 나갔습니다.")
      })
      .then(()=>{
        this.$router.push('/chat');
      })
    },
    cancelBtn() {
      this.$emit('cancelModal', this.modalShow)
    }
  }
}
